/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M.75 0H0v6.75a.75.75 0 0 0 1.5 0V2.5607l6.2197 6.2196a.75.75 0 0 0 1.0606-1.0606L2.5607 1.5H6.75a.75.75 0 0 0 0-1.5h-6Zm22.5 0H24v6.75a.75.75 0 0 1-1.5 0V2.5607l-6.2197 6.2196a.75.75 0 0 1-1.0606-1.0607L21.4393 1.5H17.25a.75.75 0 0 1 0-1.5h6ZM0 24h6.75a.75.75 0 0 0 0-1.5H2.5607l6.2196-6.2197a.75.75 0 0 0-1.0607-1.0606L1.5 21.4393V17.25a.75.75 0 0 0-1.5 0V24Zm23.25 0H24v-6.75a.75.75 0 0 0-1.5 0v4.1893l-6.2197-6.2196a.75.75 0 0 0-1.0606 0 .75.75 0 0 0 0 1.0606L21.4393 22.5H17.25a.75.75 0 0 0 0 1.5h6Z"
    clipRule="evenodd"
  />,
  'Maximize'
);
